import { CollectionStatusEnum } from "@kanpla/api-contract";

import { type Child } from "~/api/children/types";

export function getCountsByStatus(
  items: Child[]
): Record<CollectionStatusEnum | "all", number> {
  return items.reduce<Record<CollectionStatusEnum | "all", number>>(
    (acc, item) => {
      const status = item.collectionStatus ?? CollectionStatusEnum.NO_ORDERS;
      acc[status] = (acc[status] || 0) + 1;
      acc.all += 1;
      return acc;
    },
    {
      [CollectionStatusEnum.COLLECTED]: 0,
      [CollectionStatusEnum.IN_PROGRESS]: 0,
      [CollectionStatusEnum.NO_ORDERS]: 0,
      all: 0
    }
  );
}
